import { render } from "./HttpForm.vue?vue&type=template&id=46e79595"
import script from "./HttpForm.vue?vue&type=script&lang=js"
export * from "./HttpForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__